export const STORE_SELECTED_LANGUAGE = 'STORE_SELECTED_LANGUAGE';
